import { selectPromoInventory } from './selectPromoInventory';
import { IApplicationState } from '../../types/redux';

export function selectBannerStatus(state: IApplicationState) {
  const promoInventory = selectPromoInventory(state);

  return promoInventory.bannerStatus;
}
